import styled from 'styled-components';

import LayoutBase from './LayoutBase';

const Layout = styled(LayoutBase)``;

export default Layout;
